"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ModalForms = void 0;
var react_1 = __importDefault(require("react"));
var Modal_1 = require("../../Modal");
/**
 * @component Renders a form modal component with customizable submit button text and styling.
 *
 * - The props object containing the following properties:
 * @prop {React.ReactNode} children: The content to be rendered inside the form modal.
 * @prop {React.ReactNode} SUBMIT_BUTTON: The text to be displayed in the submit button.
 * @prop {string} title: The title of the form modal.
 * @prop {() => void} onClose: A function to be called when the form modal is closed.
 * @prop {'left' | 'right'} alignActions: The alignment of the actions buttons in the form modal. Defaults to "left".
 * @return {ReactElement} The rendered form modal component.
 */
var ModalForms = function (_a) {
    var children = _a.children, SUBMIT_BUTTON = _a.SUBMIT_BUTTON, title = _a.title, onClose = _a.onClose, alignActions = _a.alignActions;
    //   console.log({ SUBMIT_BUTTON: SUBMIT_BUTTON });
    return (react_1.default.createElement(Modal_1.Modal, { fitToContentHeight: true, title: title, showActionPanel: true, onClose: onClose, onCloseText: "Cancel", desktopWidth: "600px", onConfirm: SUBMIT_BUTTON, alignActions: alignActions || "left" }, children));
};
exports.ModalForms = ModalForms;
